/* eslint-disable no-alert */
import React, { Component } from 'react'
import firebase from 'firebase/app'
import { Button, Icon } from 'semantic-ui-react'

export default class AddCategory extends Component {
  addCategory = async () => {
    try {
      const { menu, menuKey, fetchMenus } = this.props
      const prompt = window.prompt(`Add new category to ${menu.name}`, '')

      if (prompt) {
        const updates = {}
        const categoryKey = firebase
          .database()
          .ref(`/menus/${menuKey}/categories`)
          .push().key

        updates[`/menus/${menuKey}/categories/${categoryKey}`] = {
          name: prompt,
        }

        const err = await firebase
          .database()
          .ref()
          .update(updates)

        if (err) {
          alert(err)
        } else fetchMenus()
      }
    } catch (error) {
      alert(error)
    }
  }

  render() {
    return (
      <Button icon size="mini" color="black" onClick={this.addCategory} style={{ marginLeft: 10 }}>
        <Icon name="add" />
      </Button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/category/components/AddCategory.js